module.exports = __webpack_public_path__ + "img/order-active.8844678c.png";